<template>
  <div class="details-wrap">
    <div class="details-block">
      <v-overlay :value="loading" v-if="loading" :opacity="0.8" color="#FFF" absolute>
        <v-progress-circular indeterminate size="64" color="#d59e1d"></v-progress-circular>
      </v-overlay>

      <div class="data-notavailblk" v-if="trip_details === undefined">Select a trip to view details</div>
      <div class="data-notavailblk" v-else-if="trip_details && Object.keys(trip_details).length === 0">Details Not Available</div>

      <div class="basic-detailsblk" v-if="trip_details && Object.keys(trip_details).length !== 0">
        <div class="trip-info-row">
          <div class="error-info-list">
            <h4>Error Log</h4>
            <ul v-for="(data, index) in trip_details.errorLog" :key="index">
              <li>{{ data.err }}</li>
              <li class="date-blk">{{ getDate(data.date) }}</li>
            </ul>
            <div class="data-notavailblk" v-if="!trip_details.errorLog || trip_details.errorLog.length === 0">No error log entries</div>
          </div>
        </div>

        <div class="trip-info-block">
          <div class="trip-info-row inner-detailsouter">
            <div class="trip-info-column">
              <span class="trip-info-label">Customer</span>
              <strong class="trip-info-field-data">{{ trip_details.employeeName || "--" }}</strong>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">Number</span>
              <strong class="trip-info-field-data">{{ trip_details.employeeMobile || "--" }}</strong>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">Station</span>
              <span class="trip-info-field-data">{{ trip_details.station || "--" }}</span>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">Responsibility Type</span>
              <span class="trip-info-field-data">{{ trip_details.tripType || "--" }}</span>
            </div>
          </div>

          <div class="trip-info-row">
            <div class="trip-info-column">
              <span class="trip-info-label">Driver Number</span>
              <span class="trip-info-field-data">{{ trip_details.driverMobile || "--" }}</span>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">Cab Number</span>
              <span class="trip-info-field-data">{{ trip_details.cabNo || "--" }}</span>
            </div>
            <div class="trip-info-column" v-if="trip_details.etsDetails && trip_details.etsDetails.reportingTime">
              <span class="trip-info-label">Reporting Time</span>
              <span class="trip-info-field-data">{{ getDate(trip_details.etsDetails.reportingTime) }}</span>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">Booking Date</span>
              <span class="trip-info-field-data">{{ getDate(trip_details.bookingDate) }}</span>
            </div>
          </div>

          <div class="trip-info-row">
            <div class="trip-info-column">
              <span class="trip-info-label">From</span>
              <span class="trip-info-field-data">{{ (trip_details.source && trip_details.source.address) || "--" }}</span>
            </div>
            <div class="trip-info-column">
              <span class="trip-info-label">To</span>
              <span class="trip-info-field-data">{{ (trip_details.destination && trip_details.destination.address) || "--" }}</span>
            </div>
          </div>
        </div>

        <div class="trip-info-block" v-if="trip_details.etsDetails && trip_details.etsDetails.employees && trip_details.etsDetails.employees.length">
          <h4>Employees</h4>
          <div class="employees-list">
            <div class="employee-row" v-for="(emp, idx) in trip_details.etsDetails.employees" :key="idx">
              <div class="employee-cell"><strong>{{ emp.name || "--" }}</strong></div>
              <div class="employee-cell">{{ emp.mobile || "--" }}</div>
              <div class="employee-cell" v-if="emp.crewId">Crew ID: {{ emp.crewId }}</div>
              <div class="employee-cell" v-if="emp.staffType">{{ emp.staffType }}</div>
              <div class="employee-cell address-cell">{{ emp.address || "--" }}</div>
            </div>
          </div>
        </div>

        <div class="trip-info-block row-block" v-if="trip_details.moredetails && trip_details.moredetails.length">
          <div class="personal-blkouter">
            <ul>
              <li v-for="(details, index) in trip_details.moredetails" :key="index">
                <span class="trip-info-label">{{ details.key }}</span>
                <span class="trip-info-field-data">{{ details.value }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
import moment from "moment";

export default {
  name: "ErrorTripDetails",
  props: {
    tripId: Number,
  },
  data: () => ({
    trip_details: undefined,
    loading: false,
  }),
  watch: {
    tripId() {
      this.getTripDetails();
    },
  },
  mounted() {
    this.getTripDetails();
  },
  methods: {
    async getTripDetails() {
      if (!this.tripId || this.tripId === 0) {
        this.trip_details = undefined;
        return;
      }
      this.loading = true;
      try {
        const response = await axios.post("trip/indigo/error/get", { id: this.tripId });
        this.trip_details = response.data || {};
      } catch (e) {
        this.trip_details = {};
      } finally {
        this.loading = false;
      }
    },
    getDate(date) {
      if (!date) return "--";
      return moment(date).format("MMM DD, YYYY HH:mm");
    },
  },
};
</script>

<style lang="scss" scoped>
.details-wrap {
  flex: 1;
  margin-left: 20px;
  display: flex;
}

.details-block {
  flex: 1;
  background: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 0px rgba(106, 7, 75, 0.15);
  padding: 20px;
  overflow-y: auto;
  position: relative;
}

.data-notavailblk {
  text-align: center;
  color: #999;
  padding: 40px 0;
}

.error-info-list {
  width: 100%;
  background: #fff3f3;
  border: 1px solid #f5c6c6;
  border-radius: 5px;
  padding: 12px 16px;
  margin-bottom: 18px;

  h4 {
    margin: 0 0 10px 0;
    color: #b30047;
  }

  ul {
    list-style: none;
    padding: 0 0 6px 0;
    margin: 0 0 10px 0;
    border-bottom: 1px dashed #e0bcbc;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    gap: 16px;

    &:last-child {
      border-bottom: none;
    }

    li {
      color: #6a0737;
      font-size: 13px;
      flex: 1;
      white-space: normal;
      word-break: break-word;

      &.date-blk {
        color: #888;
        font-size: 11px;
        flex: 0 0 auto;
        white-space: nowrap;
      }
    }
  }
}

.trip-info-block {
  background: #fafafa;
  border-radius: 5px;
  padding: 12px 16px;
  margin-bottom: 14px;

  h4 {
    margin: 0 0 8px 0;
    color: #6a0737;
    font-size: 14px;
  }
}

.trip-info-row {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  padding: 6px 0;
}

.trip-info-column {
  flex: 1 1 180px;
  min-width: 160px;
  display: flex;
  flex-direction: column;

  .trip-info-label {
    font-size: 12px;
    color: #888;
    margin-bottom: 2px;
  }

  .trip-info-field-data {
    font-size: 14px;
    color: #333;
  }
}

.employees-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.employee-row {
  display: flex;
  gap: 12px;
  padding: 8px 6px;
  border-bottom: 1px solid #eee;
  font-size: 13px;

  .employee-cell {
    flex: 1;
  }

  .address-cell {
    flex: 2;
    color: #555;
  }

  &:last-child {
    border-bottom: none;
  }
}

.personal-blkouter ul {
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    display: flex;
    justify-content: space-between;
    padding: 4px 0;
    border-bottom: 1px dashed #e5e5e5;

    .trip-info-label {
      color: #888;
      font-size: 12px;
    }

    .trip-info-field-data {
      color: #333;
      font-size: 13px;
    }
  }
}
</style>
